<div class="max-w-6xl mx-auto px-4 py-4 w-full ">
  <h1 class="text-2xl text-center sm:text-3xl font-semibold mb-6" [innerHtml]="title"></h1>

  <div class="flex flex-col"
      *ngIf="expiryDate && !isExpired">
    <p class="text-sm mb-2">
      <a class="text-blue-600 underline cursor-pointer"
         (click)="openTerms()">Terms & conditions</a>
    </p>

    <p class="text-sm text-green-700 mb-6">
      This promo code is added and valid until
      {{ expiryDate | date:'medium' }} or while supplies last.
      You will see the discount at checkout.
    </p>
  </div>

  <div *ngIf="notifications && (isExpired || (!hasPromoItems && !allProducts)) ; else normalInfo"
    class="flex justify-center min-h-[300px] items-center mt-6">
    <div class="flex flex-col gap-y-4 justify-center items-center">
      <p class="text-2xl my-auto text-center  text-red-700 mt-6 mb-6">
        {{notifications}}
      </p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <a href="/" class="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white
          shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2
          focus-visible:outline-offset-2 focus-visible:outline-primary-600">{{homeButtonText}}</a>
      </div>
      <p class="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">{{searchButtonText}}</p>
      <div class="mt-8">
        <vsf-simple-search-bar></vsf-simple-search-bar>
      </div>
    </div>
  </div>

  <ng-template #normalInfo>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-10">
      <ng-container *ngFor="let item of displayedItems; trackBy: trackById">
        <vsf-product-card
              [item]="item"
              [displaySubtitle]="false"
              [displayPrice]="true"
              [displayBuyButton]="true"
              [displayType]= "item.type"
              [displayAlternativeImage]="true"
              [isMobile]="isMobile"
              imgType="square"
              class="card product-card">
        </vsf-product-card>
      </ng-container>
    </div>
    <div class="text-center mt-8" *ngIf="displayLoadMore">
      <button class="btn btn-secondary px-6 py-2 hover:scale-105 transition"
              (click)="loadMore()">
        View more
      </button>
    </div>
  </ng-template>
</div>
